<footer>
  @if (showTopFooter) {
    <div class="top-footer">
      <div class="container p-4">
        <div class="row">

          <!-- About -->
          <div class="col-lg-4 col-md-6 mb-4 mb-lg-0">
            <h5 class="text-uppercase">Uttara University</h5>
            <p>
              Uttara University Institutional Repository preserves and provides
              open access to the scholarly works of faculty and students.
            </p>
          </div>

          <!-- Quick Links -->
          <div class="col-lg-4 col-md-6 mb-4 mb-lg-0">
            <h5 class="text-uppercase">Quick Links</h5>
            <ul class="list-unstyled mb-0">
              <li><a routerLink="/communities">Communities</a></li>
              <li><a routerLink="/collections">Collections</a></li>
              <li><a routerLink="/search">Search</a></li>
              <li>
                <a href="https://uttara.ac.bd" target="_blank">
                  Main Website
                </a>
              </li>
            </ul>
          </div>

          <!-- Contact -->
          <div class="col-lg-4 col-md-12 mb-4 mb-md-0">
            <h5 class="text-uppercase">Contact</h5>
            <p>
              Library & Information Division<br>
              Uttara University<br>
              Dhaka, Bangladesh<br>
              Email: library&#64;uttara.ac.bd
            </p>
          </div>

        </div>
      </div>
    </div>
  }

  <!-- Bottom Footer -->
  <div class="bottom-footer p-2 d-flex flex-column flex-md-row justify-content-center align-items-center text-white">

    <div class="content-container align-self-center">
      <p class="m-0">
        © {{ dateObj | date:'y' }} Uttara University Institutional Repository
      </p>

      <ul class="footer-info list-unstyled d-flex justify-content-center mb-0">

        @if (showCookieSettings) {
          <li>
            <button class="btn btn-link text-white"
                   (click)="showCookieSettings()">
              Cookies
            </button>
          </li>
        }

        <li>
          <a class="btn text-white" routerLink="info/accessibility">
            Accessibility
          </a>
        </li>

        @if (showPrivacyPolicy) {
          <li>
            <a class="btn text-white" routerLink="info/privacy">
              Privacy Policy
            </a>
          </li>
        }

        @if (showSendFeedback$ | async) {
          <li>
            <a class="btn text-white" routerLink="info/feedback">
              Feedback
            </a>
          </li>
        }

      </ul>
    </div>

    @if (coarLdnEnabled$ | async) {
      <div class="notify-enabled text-white align-self-end">
        <a class="coar-notify-support-route"
           routerLink="info/coar-notify-support">

          <img class="n-coar" src="assets/images/n-coar.svg" alt="COAR">

          COAR Notify
        </a>
      </div>
    }

  </div>
</footer>
